import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'normTypePipe'
})
export class NormTypePipe implements PipeTransform {

  transform(value: string | undefined): string {
    const labels: Record<string, string> = {
      'NORM_1300': 'B1300',
      'NORM_1301': 'B1301'
    };
    return value ? (labels[value] || value) : '';
  }
}
